import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function GetcategorySubcategory() {
  const [categories, setCategories] = useState([]);

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoryRes = await axios.get(
          "https://www.bharatcod.com/user/categories"
        );

        const categoriesWithSub = await Promise.all(
          categoryRes.data.map(async (category) => {
            const subRes = await axios.get(
              `https://www.bharatcod.com/user/categories?parentId=${category._id}`
            );
            return { ...category, subcategories: subRes.data };
          })
        );

        setCategories(categoriesWithSub);
      } catch (error) {
        console.error("Error fetching categories and subcategories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="bg-gradient-to-r from-blue-50 via-blue-100 to-blue-50 py-10 px-6 mt-5 mx-auto">
      <footer className="text-black border-t border-gray-200">
        <div className="flex flex-col gap-8">
          {categories.map((cat) => (
            <div key={cat} className="w-full">
              <h3 className="text-xl font-bold mb-3 text-rose-600">
                <Link
                  to={`/ShowCategoryData/${cat.name}/${cat._id}/${""}`}
                  className="hover:underline"
                >
                  {cat.name}
                </Link>
              </h3>

              <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
                {cat.subcategories.length > 0 ? (
                  cat.subcategories.map((sub, index) => (
                    <React.Fragment key={sub}>
                      <Link
                        to={`/category/${generateSlug(cat.name)}/${generateSlug(
                          sub?.name
                        )}`}
                        className="hover:underline cursor-pointer"
                        state={{
                          name: sub.name,
                          activeCategoryId: cat?._id,
                          activeCategory: cat?.name,
                        }}
                      >
                        {sub.name}
                      </Link>
                      {index !== cat.subcategories.length - 1 && (
                        <span className="text-gray-400">||</span>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <span className="italic text-gray-400">No subcategories</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </footer>
    </div>
  );
}

export default GetcategorySubcategory;
